import { useCallback } from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { useSellerRoles } from '../../hooks/useSellerRoles';
import { useRoleVariation } from '../../hooks/useRoleVariation';
import { translateRoleTitle } from '../../utils/translateRoleTitle';
import { useBI, buildProfessionBIExtension } from '../BIContext';

export const useReportRoleTabClick = () => {
    const { reportRoleTabClicked } = useBI();

    const sellerRoles = useSellerRoles();
    const roleVariation = useRoleVariation();

    const reporter = useCallback(
        (tabIndex: number) => {
            if (tabIndex === 0) {
                /* In case of the Overview tab, no profession extension is needed */
                reportRoleTabClicked({
                    label: translate('seller_page_perseus.professions_page.roles_tabs.overview'),
                    professionExtensionOverride: {},
                });
                return;
            }

            /* Precalculate the profession extension for the tab to be selected */
            const roleToSelect = sellerRoles[tabIndex - 1];
            const label = translateRoleTitle(roleToSelect, roleVariation[roleToSelect.id]);
            const professionExtensionOverride = buildProfessionBIExtension(
                roleToSelect,
                roleVariation[roleToSelect.id]
            );

            reportRoleTabClicked({ label, professionExtensionOverride });
        },
        [reportRoleTabClicked, sellerRoles, roleVariation]
    );

    return reporter;
};
